/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/datatypes';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "team_api": {
        "nested": {
          "RetrieveTeamMemberRequest": {
            "fields": {
              "teamMemberId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "include": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "fetchFields": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "RetrieveTeamMemberResponse": {
            "fields": {
              "teamMember": {
                "type": ".squareup.team_api.TeamMember",
                "id": 1,
                "rule": "optional"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              },
              "includedResources": {
                "type": ".squareup.team_api.TeamMemberIncludedResources",
                "id": 3,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.team_api?.nested?.RetrieveTeamMemberRequest && !$root.nested?.squareup?.nested?.team_api?.nested?.RetrieveTeamMemberResponse) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Represents a retrieve request for a `TeamMember` object.
 * --
 *
 * SOURCE RetrieveTeamMemberRequest @ squareup/team_api/endpoints/retrieve-team-member.proto at 23:1
 */
export const RetrieveTeamMemberRequest = $root.lookupType('squareup.team_api.RetrieveTeamMemberRequest');
fixType(RetrieveTeamMemberRequest, {
  teamMemberId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(RetrieveTeamMemberRequest);
/**
 * --
 * @desc Represents a response from a retrieve request containing a `TeamMember` object or error messages.
 * --
 *
 * SOURCE RetrieveTeamMemberResponse @ squareup/team_api/endpoints/retrieve-team-member.proto at 41:1
 */
export const RetrieveTeamMemberResponse = $root.lookupType('squareup.team_api.RetrieveTeamMemberResponse');
fixType(RetrieveTeamMemberResponse);
Builder.createAndAttachToType(RetrieveTeamMemberResponse);